<template>
	<div class="creatOrder layui-layout layui-layout-admin" style="background:#fff;" v-if='show'>
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="back" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i>查看购物车
			</div>
		</div>
		<div class="ggBox" style="min-width: 1000px;">
			<div style="line-height: 50px;display: flex;align-items: center;justify-content: space-around;font-size: 18px;">
				<p v-if='attrs.attr_title'>钢片规格（宽x长，单位mm）：{{attrs.attr_title}}</p>
				<p v-if='attrs.use_title'>钢片有效印刷面积（宽x长，单位mm）： {{attrs.use_title}}</p>
				<p v-if='attrs.weight'>毛重/个： {{attrs.weight}}kg</p>
				<p v-if='attrs.money'>标准价格：{{parseFloat(attrs.money) + parseFloat(user_info.pay_type_price)}}元</p>
			</div>
			<div class="f_row al_itm">
				<span>钢片厚度</span>
				<div class="f_col jc_ct">
					<div class="f_row al_itm redio" v-for="(item,index) in thickness" :key="index" @click="selThickness(index)">
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>{{item.title}}</span><span v-if='item.add_money > 0'>（{{item.add_money}}元）</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>{{gg_info.list1.title}}
					<el-popover placement="right" title="说明" width="200" trigger="click">
						<div v-html="gg_info.list1.explain"></div>
						<span class="text_color pointer" slot="reference">【说明】</span>
				</el-popover>
				</span>
				<div class="f_col jc_ct">
					<div class="f_row al_itm redio" v-for="(item,index) in gg_info.list1.data" :key="index" @click="selList1(index)" v-if='item.status == 1'>
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>{{item.title}}</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>{{gg_info.list3.title}}<el-popover placement="right" title="说明" width="200" trigger="click">
						<div v-html="gg_info.list3.explain"></div>
						<span class="text_color pointer" slot="reference">【说明】</span>
				</el-popover>
				</span>
				<div class="f_col jc_ct">
					<div class="f_row al_itm redio" v-for="(item,index) in gg_info.list3.data" :key="index" @click="selList3(index)" v-if='item.status == 1'>
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>{{item.title}}</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>{{gg_info.list4.title}}<el-popover placement="right" title="说明" width="200" trigger="click">
						<div v-html="gg_info.list4.explain"></div>
						<span class="text_color pointer" slot="reference">【说明】</span>
				</el-popover>
				</span>
				<div class="f_col jc_ct">
					<div class="f_row al_itm redio" v-for="(item,index) in gg_info.list4.data" :key="index" @click="selList4(index)" v-if='item.status == 1'>
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>{{item.title}}</span>
					</div>
					<p style="color: #FF0000;margin: 10px 12px;">注：IC引脚间距等于或小于0.5MM或有BGA封装的PCB板，建议研磨抛光工艺。如选择打磨工艺可能导致的下锡不良，我们不承担责任。</p>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>{{gg_info.list6.title}}<el-popover placement="right" title="说明" width="200" trigger="click">
						<div v-html="gg_info.list6.explain"></div>
						<span class="text_color pointer" slot="reference">【说明】</span>
				</el-popover>
				</span>
				<div class="f_col jc_ct">
					<div class="f_row al_itm redio" v-for="(item,index) in gg_info.list6.data" :key="index" @click="selList6(index)" v-if='item.status == 1'>
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>{{item.title}}</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>{{gg_info.list7.title}}<el-popover placement="right" title="说明" width="200" trigger="click">
						<div v-html="gg_info.list7.explain"></div>
						<span class="text_color pointer" slot="reference">【说明】</span>
				</el-popover>
				</span>
				<div class="f_col jc_ct">
					<div class="f_row al_itm redio" v-for="(item,index) in gg_info.list7.data" :key="index" @click="selList7(index)" v-if='item.status == 1'>
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>{{item.title}}</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm">
				<span class="min_width">CHIP<br>开孔要求<el-popover placement="right" title="说明" width="200" trigger="click">
						<div v-html="gg_info.list8.explain"></div>
						<span class="text_color pointer" slot="reference">【说明】</span>
				</el-popover>
				</span>
				<div class="f_col" style="flex: 1;">
					<div class="f_row al_itm" style="border:none;" v-if='mesh_type == 1'>
						<div class="f_col" style="width:100%;">
							<div class="f_row al_itm" style="border:none;">
								<span style="margin:0 10px;" class="tt_width blocks">防锡珠方案</span>
								<div class="f_col border_l" style="min-height: 80px;flex-wrap: wrap;flex: 1;">
									<div :class="'f_row al_itm ' + (index != 0? 'border_t':'')" v-for="(item,index) in gg_info.list8.data" :key="index">
										<div class="f_row al_itm redio" style="min-height: 50px;min-width:120px;" @click="selList8(index)">
											<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
											<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
											<span>{{item.title}}</span>
										</div>
										<div class="f_col jc_ct border_l redio" style="margin-left: 30px;padding-right: 50px;" v-if='item.p_checked && item.pid_data'>
											<div class="f_row al_itm" style="padding:10px 0;" v-for="(item2,index2) in item.pid_data" :key="index2" @click="selList8Tow(index,index2)">
												<i v-show="item2.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
												<i v-show="!item2.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
												<span style="min-width: 80px;margin-right: 20px;">{{item2.title}}</span>
												<img v-if="item2.image" :src="urls + item2.image" width="150px" />
											</div>
										</div>
										<div class="f_row al_itm border_l" v-if='item.checked && index != 0 && index != 1 && index != 2 && index != 3' style="flex: 1;height:100%;">
											<span style="margin:0 10px;" class="tt_width">防锡珠类型</span>
											<div class="f_col jc_ct border_l redio" style="width:100%;height:100%;">
												<div :class="'f_row al_itm ' + (index3 != 0? 'border_t':'')" style="padding:4px 0;flex: 1;" v-for="(item3,index3) in gg_info.list9.data" :key="index3" @click="selList9(index3)">
													<i v-show="item3.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
													<i v-show="!item3.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
													<span style="min-width: 80px;">{{item3.title}}</span>
													<img :src="urls + item3.image" style="margin-left:20px;width:20px;">
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="f_row al_itm" style="width:100%;" v-if='mesh_type == 2'>
						<div class="f_row al_itm w_100" style="width:100%;">
							<span style="margin:0 10px;" class="tt_width">红胶开孔类型</span>
							<div class="f_col jc_ct border_l redio" style="width:100%;">
								<div :class="'f_row al_itm '+(index != 0? 'border_t':'')" style="padding:4px 0;" v-for="(item,index) in gg_info.list10.data" :key="index" @click="selList10(index)">
									<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
									<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
									<span style="min-width: 80px;">{{item.title}}</span>
									<img v-if="item.image" :src="urls + item.image" alt="" style="margin-left:20px;width:20px;">
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--******新增******-->
			<div class="f_row al_itm" v-if='mesh_type != 2'>
				<span>{{gg_info.list17.title}}</span>
				<div class="f_col jc_ct" style="flex: 1;">
					<div :class="'f_row al_itm ' + (index != 0? 'border_t':'')" v-for="(item,index) in gg_info.list17.data" :key="index" v-if="!item.image">
						<div class="f_row al_itm redio" style="min-height: 50px;padding: 0 20px;" @click="selList17(index)">
							<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
							<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
							<span>{{item.title}}</span>
						</div>
						<div class="f_row border_l" style="flex: 1;" v-if='item.p_checked && item.pid_data'>
							<div class="f_col jc_ct" style="width: 200px;">
								<div class="f_row al_itm redio" style="padding:4px 0;" v-for="(item2,index2) in item.pid_data" :key="index2" @click="selList17Tow(index,index2)">
									<i v-show="item2.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
									<i v-show="!item2.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
									<span style="min-width: 80px;">开孔宽度{{item2.title}}</span>
								</div>
							</div>
							<div class="f_row al_itm border_l" v-if='item.checked && item.p_checked && index != 0 && index != gg_info.list17.data.length - 1' style="flex: 1;">
								<span style="margin:0 10px;" class="tt_width">开孔形状</span>
								<div class="f_col jc_ct border_l redio" style="width:100%;height:100%;">
									<div :class="'f_row al_itm ' + (index3 != 0? 'border_t':'')" style="padding:4px 0;flex: 1;" v-for="(item3,index3) in gg_info.list20.data" :key="index3" @click="selList20(index3)">
										<i v-show="item3.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
										<i v-show="!item3.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
										<span style="min-width: 80px;">{{item3.title}}</span>
										<img :src="urls + item3.image" style="margin-left:20px;width:150px;">
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="f_row al_itm" v-if='mesh_type != 2'>
				<span>{{gg_info.list18.title}}</span>
				<div class="f_col jc_ct" style="flex: 1;">
					<div :class="'f_row al_itm ' + (index != 0? 'border_t':'')" v-for="(item,index) in gg_info.list18.data" :key="index" v-if="!item.image">
						<div class="f_row al_itm redio" style="min-height: 50px;padding: 0 20px;" @click="selList18(index)">
							<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
							<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
							<span>{{item.title}}</span>
						</div>
						<div class="f_row border_l" style="flex: 1;" v-if='item.p_checked && item.pid_data'>
							<div class="f_col jc_ct" style="width: 200px;">
								<div class="f_row al_itm redio" style="padding:4px 0;" v-for="(item2,index2) in item.pid_data" :key="index2" @click="selList18Tow(index,index2)">
									<i v-show="item2.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
									<i v-show="!item2.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
									<span style="min-width: 80px;">开孔直径{{item2.title}}</span>
								</div>
							</div>
							<div class="f_row al_itm border_l" v-if='item.checked && item.p_checked && index != 0 && index != gg_info.list18.data.length - 1' style="flex: 1;">
								<span style="margin:0 10px;" class="tt_width">开孔形状</span>
								<div class="f_col jc_ct border_l redio" style="width:100%;height:100%;">
									<div :class="'f_row al_itm ' + (index3 != 0? 'border_t':'')" style="padding:4px 0;flex: 1;" v-for="(item3,index3) in gg_info.list21.data" :key="index3" @click="selList21(index3)">
										<i v-show="item3.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
										<i v-show="!item3.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
										<span style="min-width: 80px;">{{item3.title}}</span>
										<img v-if='item3.image' :src="urls + item3.image" style="margin-left:20px;width:150px;">
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="f_row al_itm" v-if='mesh_type != 2'>
				<span>{{gg_info.list19.title}}</span>
				<div class="f_col jc_ct" style="flex: 1;">
					<div :class="'f_row al_itm ' + (index != 0? 'border_t':'')" v-for="(item,index) in gg_info.list19.data" :key="index">
						<div style="width: 150px;text-align: center;">{{item.title}}</div>
						<div class="f_col border_l">
							<div class="f_row al_itm redio" style="padding:4px 0;" v-for="(item2,index2) in item.pid_data" :key="index2" @click="selList19Tow(index,index2)">
								<i v-show="item2.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
								<i v-show="!item2.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
								<span style="min-width: 80px;">{{item2.title}}</span>
								<img v-if='item2.image' :src="urls + item2.image" style="margin-left:20px;width:150px;">
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--****************-->
			<div class="f_row al_itm">
				<span>排版方式</span>
				<div class="f_row al_itm" style="flex: 1;">
					<div class="f_col jc_ct min_width" style="padding-right:10px;">
						<div class="f_row al_itm redio" v-for="(item,index) in gg_info.list11.data" :key="index" @click="selList11(index)">
							<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
							<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
							<span>{{item.title}}</span>
						</div>
					</div>
					<div class="f_row al_itm w_100 border_l" style="height: 250px;">
						<div class="al_itm jc_ct border_r" style="width:50%;height: 250px;">
							<img src="../assets/image1.png" style="width: 260px;cursor: pointer;" id="image1" title="点击查看大图" @click="bigImgShow(1)">
						</div>
						<div class="al_itm jc_ct" style="width:50%;height: 250px;">
							<img src="../assets/image2.png" style="width: 260px;cursor: pointer;" id="image2" title="点击查看大图" @click="bigImgShow(2)">
						</div>
					</div>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>{{gg_info.list12.title}}</span>
				<div class="f_col jc_ct">
					<div class="f_row al_itm redio" v-for="(item,index) in gg_info.list12.data" :key="index" @click="selList12(index)">
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>{{item.title}}</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>上传资料</span>
				<div class="f_col jc_ct" style="text-align: center;">
					<p>请上传压缩包文件</p>
					<button type="button" id="upload" class="layui-btn zt_color" style="margin:0 10px;width: 121px;">
                  		<i class="layui-icon"  style="position: relative;top: 2px;left: -5px;">&#xe67c;</i>{{files ? '已上传' : '上传文件'}}
                	</button>
				</div>
				<a v-if='files' :href="files" style="color: rgb(72, 118, 255);">工程包文件.zip</a>
			</div>
			<div class="f_row w_100">
				<div class="f_col f_warp" style="border: none;padding: 20px;">
					<p>（请确认上传资料中是否具备以下gbr层）<span style="color: #FF0000;"></span></p>
					<div class="f_row al_itm redio" style="padding: 4px 0;" v-for="(item,index) in gg_info.list13.data" :key="index" @click="selList13(index)">
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span><i style="color: #FF0000;margin: 0 5px 0 0;line-height: 40px;">*</i>{{item.title}}</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>请确认gerber资料是否齐全</span>
				<div class="f_row al_itm redio" @click="confirm">
					<i v-show="all_dataIsok" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
					<i v-show="!all_dataIsok" class="layui-icon-circle layui-icon px20 color_80"></i>
					<span>确认</span>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>是否需要送货单及收据</span>
				<div class="f_col jc_ct" style="flex: 1;">
					<div style="width:100%;padding:10px 0;border-bottom:1px solid #ccc;" v-if="is_invoice == 1">
						<span>收据抬头:</span>
						<input type="text" v-model="invoice_head" style="border-bottom: 1px dashed #bbb;border-top:0;border-left:0;border-right:0;">
					</div>
					<div class="f_row al_itm redio" @click="selList14(1)">
						<i v-if="is_invoice == 1" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-else class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>需要</span>
					</div>
					<div class="f_row al_itm redio" @click="selList14(0)">
						<i v-if="is_invoice != 1" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-else class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>不需要</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm " style="height: 40px;min-height: 40px;padding-left: 20px;">收货信息</div>
			<div class="f_row al_itm">
				<div class="f_row jc_ct al_itm" style="width:50%;border: none;">
					收货地址:
					<div class="selAddr" v-if="selAddr">{{selAddr.province}} {{selAddr.city}} {{selAddr.area}} <br /> {{selAddr.address}}</div>
					<button class="layui-btn zt_color" style="margin-left: 20px;" @click="selAddress">
		                    收货地址<i class="layui-icon layui-icon-right" style="position: relative;top: 2px;left: -5px;"></i>
		                </button>
				</div>
				<div class="f_row al_itm jc_ct border_l" style="width:50%;height:100%;min-height: 80px;">
					订单联系人:
					<div class="selAddr" v-if="selCont">联系人姓名：{{selCont.name}} <br /> 联系人电话：{{selCont.mobile}}</div>
					<button class="layui-btn zt_color" style="margin-left: 20px;" @click="selContact">
                    		订单联系人<i class="layui-icon layui-icon-right" style="position: relative;top: 2px;left: -5px;"></i>
                  		</button>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>{{gg_info.list15.title}}</span>
				<div class="f_col jc_ct">
					<div class="f_row al_itm redio" v-for="(item,index) in gg_info.list15.data" :key="index" @click="selList15(index)">
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>{{item.title}}</span><span v-if='item.add_money > 0'>（{{item.add_money}}元）</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm" v-if="kd_info.length > 0">
				<span>快递信息</span>
				<div class="f_col jc_ct" style="flex: 1;">
					<div class="f_row al_itm redio" :class="index > 0 ? 'border_t' : ''" v-for="(item,index) in kd_info" v-if="item.use_status" :key="index" @click="checkedIndex(index)">
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span style="display: inline-block;width: 100px;">{{item.company}}</span>
						<span style="color: #999999;font-size: 12px;" v-show="item.company != '自提' && item.company != '自配送'">{{item.type==1?'市内':item.type==2?'省内':'省外'}} 首重({{item.initial_weight}}KG){{item.freight}}元   续重{{item.excess_freight}}元/KG</span>
						<span style="color: #999999;font-size: 12px;" v-show="(item.company == '自提' || item.company == '自配送') && item.freight > 0">{{item.freight}}元/件</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm">
				<label class="layui-form-label f_row al_itm" style="width:130px;min-height:80px;padding:0 0 0 20px;color: #FF0000;">特殊要求备注：</label>
				<input v-model="remark" maxlength="120" style="width:100%;height:100%;border:none;" type="text" placeholder="请输入特殊要求备注">
			</div>
			<div class="f_row al_itm">
				<span>其他产品</span>
				<div class="f_row jc_ct">
					<div class="f_row al_itm redio" v-for="(item,index) in gg_info.list2.data" :key="index" @click="selList2(index)">
						<i v-show="item.checked" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
						<i v-show="!item.checked" class="layui-icon-circle layui-icon px20 color_80"></i>
						<span>{{item.title}}</span>
					</div>
				</div>
			</div>
			<div class="f_row al_itm">
				<span>购买数量</span>
				<div class="f_row al_itm jc_ct" style="padding: 0 10px;">
					<el-input-number v-model="num" @change="handleChange" :min="1" :max="10" step-strictly></el-input-number>
				</div>
			</div>
		</div>
		<div class="f_row al_itm" style="width: 94%;margin: 20px 3%;">
			<span style="color: #FF0000;">请再次确认本订单所有信息是否准确</span>
			<div class="f_row al_itm redio" @click="selList16" style="margin-left: 20px;">
				<i v-show="all_dataIsok2" class="layui-icon-radio layui-icon px20 zt_txt_color"></i>
				<i v-show="!all_dataIsok2" class="layui-icon-circle layui-icon px20 color_80"></i>
				<span style="margin-left: 5px;">确认</span>
			</div>
		</div>
		<div style="margin: 0 0 20px 3%;" v-if='tax > 0'>费用合计：<span style="color: rgb(255, 152, 0);">{{money + kd_money + tax}}</span> 元 (钢网{{money}}元+运费{{kd_money}}元+税点{{tax}}元)</div>
		<div style="margin: 0 0 20px 3%;" v-else>费用合计：<span style="color: rgb(255, 152, 0);">{{money + kd_money}}</span> 元 (钢网{{money}}元+运费{{kd_money}}元)</div>

		<div class="f_row al_itm jc_sb" style="width:94%;margin-left:3%;padding-bottom: 50px;">
			<button class="layui-btn zt_color" style="width:35%;" @click="onPay(2)">立即结算</button>
			<button class="layui-btn color_c" style="width:35%;" @click="onPay(1)">保存</button>
		</div>
		<!--弹出层-->
		<div class="layer" v-if='zzc'></div>
		<div class="bigImg" v-if="big == 1">
			<i class="layui-icon layui-icon-close-fill" style="color: rgba(0,0,0,0.5);font-size: 40px;" @click="bigImgHide"></i>
			<img src="../assets/image1.png" style="width: 800px;" />
		</div>
		<div class="bigImg" v-if="big == 2">
			<i class="layui-icon layui-icon-close-fill" style="color: rgba(0,0,0,0.5);font-size: 40px;" @click="bigImgHide"></i>
			<img src="../assets/image2.png" style="width: 800px;" />
		</div>
		<div id="address" style="display: none;margin: 20px 30px 60px 30px;">
			<table class="layui-table" lay-skin="nob">
				<colgroup>
					<col width="150">
					<col width="200">
					<col>
				</colgroup>
				<thead>
					<tr>
						<th class="align_center"></th>
						<th class="align_center">姓名</th>
						<th class="align_center">电话</th>
						<th class="align_center">地址</th>
						<th class="align_center">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in address" :key="i">
						<td class="align_center">
							<span v-if="item.is_default" class="zt_color txt_white blocks" style="width:55px;margin:0 auto;">默认</span>
						</td>
						<td class="align_center">{{item.name}}</td>
						<td class="align_center">{{item.mobile}}</td>
						<td class="align_center" style="width:40%;">{{item.province+ item.city + item.area + item.address}}</td>
						<td class="align_center">
							<span @click="setTheAddr(item)" class="pointer" style="color:rgb(255, 152, 0);">选择</span>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-if='address == [] || address.length == 0 || !address' style="width: 100%;line-height: 100px;text-align: center;color: #ccc;font-size: 18px;">暂无数据</div>
		</div>
		<div id="contact" style="display: none;margin: 20px 30px 60px 30px;">
			<table class="layui-table" lay-skin="nob">
				<colgroup>
					<col width="150">
					<col width="200">
					<col>
				</colgroup>
				<thead>
					<tr>
						<th class="align_center"></th>
						<th class="align_center">姓名</th>
						<th class="align_center">电话</th>
						<th class="align_center">操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item,i) in contact" :key="i">
						<td class="align_center">
							<span v-if="item.is_default" class="zt_color txt_white blocks" style="width:55px;margin:0 auto;">默认</span>
						</td>
						<td class="align_center">{{item.name}}</td>
						<td class="align_center">{{item.mobile}}</td>
						<td class="align_center">
							<span @click="setTheContact(item)" class="pointer" style="color:rgb(255, 152, 0);">选择</span>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-if='contact == [] || contact.length == 0 || !contact' style="width: 100%;line-height: 100px;text-align: center;color: #ccc;font-size: 18px;">暂无数据</div>
		</div>
		<div id="lay-box" style="display: none;">
			<div>如果您需要确认PDF文件才能安排切割，那么在您确认文档没有问题之前，我们不会安排切割。<span style="color: rgba(229, 28, 35, 1);">由此造成的交期延误，我们不承担一切的责任。</span></div>
		</div>
		<div id="lay-box2" style="display: none;">
			<div>1.如果您选择需要确认PDF文档后才能切割，在您付款订单之后，我们工程安排处理文件，资料处理完之后，需要您到系统上确认文档。</div>
			<div>2.因为工程处理完成的时间，有可能是晚上才处理好，而且很难确定什么时候处理好，<span style="color: rgba(229, 28, 35, 1);">需要您时时关注我们的系统</span>，请问您是否确实需要确认PDF文档？</div>
		</div>
		<div id="lay-box3" style="display: none;">
			<div>您选择了需要确认PDF文档后才能切割，为了方便通知您及时上网确认订单，关注公众号，它会实时通知您去确认PDF文档。<span style="color: rgba(229, 28, 35, 1);">我们暂不提供系统之外的消息通知（我们不会给您打电话、发短信去通知您来确认PDF文档）</span>，请务必知悉。其次，对于有问题的资料，我们内部工程会统一处理，<span style="color: rgba(229, 28, 35, 1);">有可能会比较晚联系您</span>，请知悉。</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				show: false,
				title: '',
				content: '',
				is_sub: '',
				urls: 'https://mr.summary88.com',
				dscModel: false,
				attrs: '', //规格信息
				thickness: [], //厚度
				money: 0, //订单金额
				tax: 0, //税费
				mesh_type: 1, //钢网用途-1锡膏工艺2红胶工艺
				remark: '', //备注
				files: '', //文件路径
				tables: '',
				datas: [],
				address: [], //收货地址列表
				selAddr: '',
				contact: [], //联系人列表
				selCont: '',
				mesh_num: 1,
				gg_info: false,
				all_dataIsok: false,
				all_dataIsok2: false,
				invoice_head: '', //收据抬头
				is_invoice: 1, //是否需要发票
				kd_info: [], //选择快递
				kd_index: 0,
				kd_type: 0, //1市内，2省内，3省外
				kd_money: 0, //快递费用
				zzc: false, //遮罩层
				big: 0,
				shopCarMsg: '',
				shopcar_id: 0,
				num: 1, //购买数量
				user_info: ''
			}
		},
		created() {
			let _this = this;
			api.getMemberInfo({ //获取会员信息
				token: _this.getCookie('token')
			}).then((res) => {
				if(res.code == 1) {
					_this.user_info = res.data;
				} else if(res.code == 0) {
					layer.msg(res.msg, {
						icon: 2,
						anim: 6
					})
				}
			});
			layui.use('layer', () => {
				api.getShopCarDetail({ //获取购物车详情
					token: _this.getCookie('token'),
					id: this.$route.query.id
				}).then((res) => {
					if(res.code == 1) {
						_this.shopCarMsg = res.data;
						_this.mesh_type = res.data.mesh_type;
						_this.num = res.data.buy_num;
						_this.getAttr();
					} else if(res.code == 0) {
						layer.msg(res.msg, {
							icon: 2,
							anim: 6
						})
					}
				});
			});
		},
		mounted() {
			this.shopcar_id = this.$route.query.id || 0;
		},
		methods: {
			onGetAddressMsg() {
				let _this = this;
				api.getAddressList({ //获取收货地址
					token: this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						for(let i = 0; i < res.data.length; i++) {
							if(res.data[i].is_default == 1) {
								_this.selAddr = res.data[i];
								_this.expressDetail(res.data[i]);
							}
						}
						if(!_this.address && res.data.length > 0) {
							_this.selAddr = res.data[0];
							_this.expressDetail(res.data[0]);
						}
					} else {
						layer.msg('请先添加收货地址', {
							icon: 2,
							anim: 6
						})
						return false;
					}
				})
				api.getContactList({ //获取联系人
					token: this.getCookie('token')
				}).then((res) => {
					if(res.code == 1) {
						for(let i = 0; i < res.data.length; i++) {
							if(res.data[i].is_default == 1) {
								_this.selCont = res.data[i];
							}
						}
						if(!_this.contact && res.data.length > 0) {
							_this.selCont = res.data[0];
						}
					} else {
						layer.msg('请先添加联系人', {
							icon: 2,
							anim: 6
						})
						return false;
					}
				})
			},
			//购买数量
			handleChange(value) {
				this.num = value;
				this.total()
			},
			back() {
				this.$router.go(-1);
			},
			getAttr() {
				let _this = this;
				api.attr({
					token: this.getCookie('token'),
					is_sub: this.is_sub,
					type: 1
				}).then((res) => {
					if(res.code == 1) {
						_this.onGetAddressMsg(); //默认选择收货地址和联系人
						_this.attrs = res.data[0];
						//钢网厚度
						api.getMeshAttrInfo({
							attr_id: res.data[0].id,
							token: _this.getCookie('token'),
						}).then((res1) => {
							if(res1.code == 1) {
								for(let i = 0; i < res1.data.length; i++) {
									res1.data.checked = 0;
									if(res1.data[i].id == _this.shopCarMsg.attr_info_id) {
										res1.data[i].checked = 1;
									}
								}
								_this.thickness = res1.data;
							}
						})
						//钢网参数
						api.getAttrs({
							recharge_id: res.data[0].recharge_id,
							type: 1,
						}).then((res) => {
							let item = res.data.list1.data[0] || '';
							res.data.list1.data.splice(0, 1);
							res.data.list1.data.splice(2, 0, item);
							_this.all_dataIsok = 1;
							_this.all_dataIsok2 = 1;
							for(let i = 0; i < res.data.list1.data.length; i++) {
								res.data.list1.data[i].checked = 0;
								if(res.data.list1.data[i].id == _this.shopCarMsg.make_demand) {
									res.data.list1.data[i].checked = 1;
								}
							}
							for(let i = 0; i < res.data.list2.data.length; i++) {
								res.data.list2.data[i].checked = 0;
								if(res.data.list2.data[i].id == _this.shopCarMsg.other_product) {
									res.data.list2.data[i].checked = 1;
								}
							}
							for(let i = 0; i < res.data.list3.data.length; i++) {
								res.data.list3.data[i].checked = 0;
								if(res.data.list3.data[i].id == _this.shopCarMsg.mesh_purpose) {
									res.data.list3.data[i].checked = 1;
								}
							}
							for(let i = 0; i < res.data.list4.data.length; i++) {
								res.data.list4.data[i].checked = 0;
								if(res.data.list4.data[i].id == _this.shopCarMsg.mark_craft) {
									res.data.list4.data[i].checked = 1;
								}
							}
							for(let i = 0; i < res.data.list5.data.length; i++) {
								res.data.list5.data[i].checked = 0;
								if(res.data.list5.data[i].id == _this.shopCarMsg.thick_num) {
									res.data.list5.data[i].checked = 1;
								}
							}
							for(let i = 0; i < res.data.list6.data.length; i++) {
								res.data.list6.data[i].checked = 0;
								if(res.data.list6.data[i].id == _this.shopCarMsg.laser_marking) {
									res.data.list6.data[i].checked = 1;
								}
							}
							for(let i = 0; i < res.data.list7.data.length; i++) {
								res.data.list7.data[i].checked = 0;
								if(res.data.list7.data[i].id == _this.shopCarMsg.mark_point) {
									res.data.list7.data[i].checked = 1;
								}
							}
							//*****************
							for(let i = 0; i < res.data.list8.data.length; i++) { //CHIP开孔要求
								res.data.list8.data[i].checked = 0;
								if(res.data.list8.data[i].id == _this.shopCarMsg.solder_hole_one) {
									res.data.list8.data[i].checked = 1;
									res.data.list8.data[i].p_checked = 1;
									if(res.data.list8.data[i].pid_data && res.data.list8.data[i].pid_data.length > 0) {
										for(let j = 0; j < res.data.list8.data[i].pid_data.length; j++) {
											if(res.data.list8.data[i].pid_data[j].id == _this.shopCarMsg.solder_hole_two) {
												res.data.list8.data[i].pid_data[j].checked = 1;
											}
										}
									}
								}
							}
							for(let i = 0; i < res.data.list9.data.length; i++) { //CHIP开孔要求-锡膏工艺开孔形状
								res.data.list9.data[i].checked = 0;
								if(res.data.list9.data[i].id == _this.shopCarMsg.solder_hole_type) {
									res.data.list9.data[i].checked = 1;
								}
							}
							for(let i = 0; i < res.data.list17.data.length; i++) { //IC集成电路
								res.data.list17.data[i].checked = 0;
								if(res.data.list17.data[i].id == _this.shopCarMsg.ic_open_ask) {
									res.data.list17.data[i].checked = 1;
									res.data.list17.data[i].p_checked = 1;
									if(res.data.list17.data[i].pid_data) {
										for(let j = 0; j < res.data.list17.data[i].pid_data.length; j++) {
											if(res.data.list17.data[i].pid_data[j].id == _this.shopCarMsg.ic_open_ask_two) {
												res.data.list17.data[i].pid_data[j].checked = 1;
											}
										}
									}
								}
							}
							for(let i = 0; i < res.data.list20.data.length; i++) { //IC集成电路-形状
								res.data.list20.data[i].checked = 0;
								if(res.data.list20.data[i].id == _this.shopCarMsg.ic_open_shape) {
									res.data.list20.data[i].checked = 1;
								}
							}
							for(let i = 0; i < res.data.list18.data.length; i++) { //BGA封装
								res.data.list18.data[i].checked = 0;
								if(res.data.list18.data[i].id == _this.shopCarMsg.bga_open_ask) {
									res.data.list18.data[i].checked = 1;
									res.data.list18.data[i].p_checked = 1;
									if(res.data.list18.data[i].pid_data) {
										res.data.list18.data[i].pid_data[0].checked = 1;
										for(let j = 0; j < res.data.list18.data[i].pid_data.length; j++) {
											if(res.data.list18.data[i].pid_data[j].id == _this.shopCarMsg.bga_open_ask_two) {
												res.data.list18.data[i].pid_data[j].checked = 1;
											}
										}
									}
								}
							}
							for(let i = 0; i < res.data.list21.data.length; i++) { //BGA封装-形状
								res.data.list21.data[i].checked = 0;
								if(res.data.list21.data[i].id == _this.shopCarMsg.bga_open_shape) {
									res.data.list21.data[i].checked = 1;
								}
							}
							
							for(let i = 0; i < res.data.list19.data[0].pid_data.length; i++) { //散热pad 开孔形状
								res.data.list19.data[0].pid_data[i].checked = 0;
								if(res.data.list19.data[0].pid_data[i].id == _this.shopCarMsg.pad_open_shape) {
									res.data.list19.data[0].pid_data[i].checked = 1;
								}
							}
							
							for(let i = 0; i < res.data.list19.data[1].pid_data.length; i++) { //散热pad 开孔面积
								res.data.list19.data[1].pid_data[i].checked = 0;
								if(res.data.list19.data[1].pid_data[i].id == _this.shopCarMsg.pad_open_area) {
									res.data.list19.data[1].pid_data[i].checked = 1;
								}
							}

							//*****************
							for(let i = 0; i < res.data.list10.data.length; i++) {
								res.data.list10.data[i].checked = 0;
								if(res.data.list10.data[i].id == _this.shopCarMsg.glue_hole_type) {
									res.data.list10.data[i].checked = 1;
								}
							}
							for(let i = 0; i < res.data.list11.data.length; i++) {
								res.data.list11.data[i].checked = 0;
								if(res.data.list11.data[i].id == _this.shopCarMsg.compose_type) {
									res.data.list11.data[i].checked = 1;
								}
							}
							for(let i = 0; i < res.data.list12.data.length; i++) { //工程处理要求
								res.data.list12.data[i].checked = 0;
							}
							if(_this.shopCarMsg.handle_demand == 1) {
								res.data.list12.data[0].checked = 1;
							} else if(_this.shopCarMsg.handle_demand == 2) {
								res.data.list12.data[1].checked = 1;
							}
							for(let i = 0; i < res.data.list13.data.length; i++) {
								res.data.list13.data[i].checked = 1;
							}
							_this.remark = _this.shopCarMsg.message; //备注
							_this.files = _this.shopCarMsg.pdf_file; //上传的文件
							_this.is_invoice = _this.shopCarMsg.is_invoice; //是否需要发票
							_this.invoice_head = _this.shopCarMsg.invoice_title; //发票抬头
							for(let i = 0; i < res.data.list15.data.length; i++) {
								res.data.list15.data[i].checked = 0;
								if(_this.shopCarMsg.is_fast == 57) {
									res.data.list15.data[0].checked = 1;
								} else {
									res.data.list15.data[1].checked = 1;
								}
							}
							_this.gg_info = res.data;
							_this.show = true;
							_this.total();
							setTimeout(() => {
								layui.use('upload', () => {
									var upload = layui.upload;
									var uploadInst = upload.render({
										elem: '#upload', //绑定元素
										url: 'https://mr.summary88.com/api/Common/OssUploadFile', //上传接口
										accept: 'file',
										number: 1,
										field: 'file',
										exts: 'zip|rar|7z',
										before: function(obj) {
											layer.msg('上传中', {
												icon: 16,
												shade: 0.01
											});
										},
										done: function(res) {
											layer.closeAll('loading'); //关闭loading
											if(res.code == 1) {
												_this.files = res.image_url;
												layer.msg('上传成功', {
													icon: 1,
													anim: 5
												})
											} else {
												layer.msg(res.msg, {
													icon: 2,
													anim: 6
												})
											}
										},
										error: function(err) {
											console.log(err) //请求异常回调
										}
									});
								});
							}, 100)
						})
					}
				})
			},
			onExplain(explain) {
				layui.use('layer', () => {
					let layer = layui.layer;
					layer.open({
						type: 0,
						title: '说明',
						content: explain,
						btn: ['确定'],
						btnAlign: 'c',
						resize: false,
						yes: function(index, layero) {
							layer.closeAll();
						}
					});
				})
			},
			bigImgShow(num) {
				this.big = num;
				this.zzc = true;
			},
			bigImgHide() {
				this.big = 0;
				this.zzc = false;
			},
			expressDetail(item) {
				let _this = this;
				this.kd_index = 0;
				if(item.province && item.city) {
					let city = item.province + ',' + item.city
					api.expressDetail({ //快递公司列表
						token: this.getCookie('token'),
						provinces: city,
						lng: item.lng,
						lat: item.lat
					}).then((res) => {
						if(res.code == 1) {
							res.data.forEach(function(val, i) {
								val.checked = false;
								if(val.ix_prev == 1) {
									_this.kd_index = i;
								}
								val.freight = parseFloat(val.freight);
								if(val.ix_prev == 1) {
									val.checked = true;
								}
							})
							_this.kd_info = res.data;
							_this.total();
							layer.closeAll();
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				} else {
					layer.msg('收货地址数据有误', {
						icon: 2,
						anim: 6
					})
				}
			},
			checkedIndex(index) { //选择快递公司
				this.kd_info.forEach(function(val, i) {
					val.checked = false;
					if(i == index) {
						val.checked = true;
					}
				})
				this.kd_index = index;
				this.kd_type = this.kd_info[index].type;
				//this.kd_money = parseFloat(this.kd_info[index].freight);
				//二期
				let weight = this.attrs.weight * this.num;
				if(this.kd_info[index].company == '自配送' || this.kd_info[index].company == '自提') {
					this.kd_money = parseFloat(this.kd_info[index].freight * this.num);
				} else {
					if(this.kd_info[index].initial_weight > weight) { //规格重量*数量小于首重
						this.kd_money = parseFloat(this.kd_info[index].freight);
					} else { //规格重量*数量大于首重
						let shou_money = parseFloat(this.kd_info[index].freight);
						let xv_money = Math.ceil(weight - this.kd_info[index].initial_weight) * this.kd_info[index].excess_freight;
						this.kd_money = parseFloat(shou_money + xv_money);
					}
				}
				//二期-end
			},
			total() {
				if(this.kd_info.length > 0) {
					this.checkedIndex(this.kd_index);
				}
				this.money = 0;
				for(var val in this.gg_info) {
					for(let i = 0; i < this.gg_info[val].data.length; i++) {
						if(this.mesh_type == 1 && val == 'list10') {
							continue;
						}
						if(this.mesh_type == 2 && (val == 'list8' || val == 'list9')) {
							continue;
						}
						if(this.gg_info[val].data[i].checked && this.gg_info[val].data[i].add_money > 0) {
							this.money += this.gg_info[val].data[i].add_money;
						}
					}
				}
				for(let i = 0; i < this.thickness.length; i++) {
					if(this.thickness[i].checked) {
						this.money += this.thickness[i].add_money;
					}
				}
				let money = parseFloat(this.money) + parseFloat(this.attrs.money) + parseFloat(this.user_info.pay_type_price);
				money = parseFloat(money * this.num).toFixed(2)
				this.money = parseFloat(money);
				if(this.$store.state.invoice == 1) {
					this.tax = parseFloat(this.money * 0.13).toFixed(2);
					this.tax = parseFloat(this.tax);
				}
			},
			onPay(num) {
				let _this = this;
				if(!this.files) {
					layer.msg('请上传工程包', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				if(!this.all_dataIsok) {
					layer.msg('请确认gerber资料是否齐全', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				if(!this.selAddr && num == 2) {
					layer.msg('请选择收货地址', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				if(!this.selCont && num == 2) {
					layer.msg('请选择收货联系人', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				let list13_id = [];
				for(let i = 0; i < this.gg_info.list13.data.length; i++) {
					if(this.gg_info.list13.data[i].checked) {
						list13_id.push(this.gg_info.list13.data[i].id);
					}
				}
				if(list13_id.length < 5) {
					layer.msg('请确认上传资料中的文件是否齐全', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				if(this.is_invoice == 1 && !this.invoice_head) {
					layer.msg('请输入收据抬头', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				if(this.remark == '') {
					layer.msg('请输入备注', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				if(!this.all_dataIsok2) {
					layer.msg('请再次确认本订单所有信息是否准确', {
						icon: 2,
						anim: 6
					})
					return false;
				}
				this.total();
				if(num == 1) {
					this.createOrder(1)
				} else if(num == 2) {
					layer.open({
						type: 0,
						content: '是否确认结算？',
						btn: ['确定', '取消'],
						btnAlign: 'c',
						resize: false,
						closeBtn: 0,
						skin: 'demo-class',
						yes: function(index, layero) {
							layer.closeAll();
							_this.createOrder(2);
						},
						btn2: function(index, layero) {
							layer.closeAll();
						}
					});
				}
			},
			createOrder(num) { //创建订单
				let _this = this;
				let list1_id = 0,
					list2_id = 0,
					list3_id = 0,
					list4_id = 0,
					list5_id = 0,
					list6_id = 0,
					list7_id = 0,
					list8_id = 0,
					list9_id = 0,
					list10_id = 0,
					list11_id = 0,
					list12_id = 0,
					list13_id = [],
					list14_id = 0,
					list15_id = 0,
					list16_id = 0,
					mesh_type = 0; //锡膏或红胶
				for(let i = 0; i < this.gg_info.list1.data.length; i++) { //制作要求
					if(this.gg_info.list1.data[i].checked) {
						list1_id = this.gg_info.list1.data[i].id;
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list2.data.length; i++) { //其他产品
					if(this.gg_info.list2.data[i].checked) {
						list2_id = this.gg_info.list2.data[i].id;
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list3.data.length; i++) { //钢网用途
					if(this.gg_info.list3.data[i].checked) {
						list3_id = this.gg_info.list3.data[i].id;
						if(i < 5) {
							mesh_type = 1;
							this.mesh_type = 1;
						} else {
							mesh_type = 2;
							this.mesh_type = 2;
						}
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list4.data.length; i++) { //制作工艺
					if(this.gg_info.list4.data[i].checked) {
						list4_id = this.gg_info.list4.data[i].id;
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list5.data.length; i++) { //钢片厚度
					if(this.gg_info.list5.data[i].checked) {
						list5_id = this.gg_info.list5.data[i].id;
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list6.data.length; i++) { //SMT活动钢网 标识信息
					if(this.gg_info.list6.data[i].checked) {
						list6_id = this.gg_info.list6.data[i].id;
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list7.data.length; i++) { //Mark基准点
					if(this.gg_info.list7.data[i].checked) {
						list7_id = this.gg_info.list7.data[i].id;
						break;
					}
				}
				let list8_id2 = 0;
				for(let i = 0; i < this.gg_info.list8.data.length; i++) { //Chip元件开孔--防锡珠开孔
					if(this.gg_info.list8.data[i].checked && mesh_type == 1) {
						list8_id = this.gg_info.list8.data[i].id;
						if(this.gg_info.list8.data[i].pid_data && this.gg_info.list8.data[i].pid_data.length > 0) {
							for(let j = 0; j < this.gg_info.list8.data[i].pid_data.length; j++) {
								if(this.gg_info.list8.data[i].pid_data[j].checked) {
									list8_id2 = this.gg_info.list8.data[i].pid_data[j].id;
								}
							}
						}
					}
				}

				for(let i = 0; i < this.gg_info.list9.data.length; i++) { //防锡珠类型
					//选择了1:1开孔或者蒙瑞技术要求则不需要该选项
					if(this.gg_info.list9.data[i].checked && mesh_type == 1 && list8_id != '34' && list8_id != '35' && list8_id != '36' && list8_id != '37') {
						list9_id = this.gg_info.list9.data[i].id;
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list10.data.length; i++) { //红胶开孔类型
					if(this.gg_info.list10.data[i].checked && mesh_type == 2) {
						list10_id = this.gg_info.list10.data[i].id;
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list11.data.length; i++) { //排版方式
					if(this.gg_info.list11.data[i].checked) {
						list11_id = this.gg_info.list11.data[i].id;
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list12.data.length; i++) { //工程处理要求
					if(this.gg_info.list12.data[i].checked) {
						list12_id = this.gg_info.list12.data[i].id;
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list13.data.length; i++) { //请确认上传资料中是否具备以下gbr层
					if(this.gg_info.list13.data[i].checked) {
						list13_id.push(this.gg_info.list13.data[i].id);
					}
				}
				for(let i = 0; i < this.gg_info.list15.data.length; i++) { //交付类型
					if(this.gg_info.list15.data[i].checked) {
						list15_id = this.gg_info.list15.data[i].id;
						break;
					}
				}
				let list17_id = 0;
				let list17_id2 = 0;
				let list20_id = 0;
				for(let i = 0; i < this.gg_info.list17.data.length; i++) { //IC集成电路 开孔要求 
					if(this.gg_info.list17.data[i].checked) {
						list17_id = this.gg_info.list17.data[i].id;
						if(this.gg_info.list17.data[i].pid_data && this.gg_info.list17.data[i].pid_data.length > 0) {
							for(let j = 0; j < this.gg_info.list17.data[i].pid_data.length; j++) {
								if(this.gg_info.list17.data[i].pid_data[j].checked) {
									list17_id2 = this.gg_info.list17.data[i].pid_data[j].id;
								}
							}
						}
						if(i != 0 && i != this.gg_info.list17.data.length - 1) {
							for(let j = 0; j < this.gg_info.list20.data.length; j++) { // IC集成电路开孔形状
								if(this.gg_info.list20.data[j].checked) {
									list20_id = this.gg_info.list20.data[j].id;
								}
							}
						}
					}
				}
				let list18_id = 0;
				let list18_id2 = 0;
				let list21_id = 0;
				for(let i = 0; i < this.gg_info.list18.data.length; i++) { //BGA封装 开孔要求
					if(this.gg_info.list18.data[i].checked) {
						list18_id = this.gg_info.list18.data[i].id;
						if(this.gg_info.list18.data[i].pid_data && this.gg_info.list18.data[i].pid_data.length > 0) {
							for(let j = 0; j < this.gg_info.list18.data[i].pid_data.length; j++) {
								if(this.gg_info.list18.data[i].pid_data[j].checked) {
									list18_id2 = this.gg_info.list18.data[i].pid_data[j].id;
								}
							}
						}
						if(i != 0 && i != this.gg_info.list18.data.length - 1) {
							for(let j = 0; j < this.gg_info.list21.data.length; j++) { // IC集成电路开孔形状
								if(this.gg_info.list21.data[j].checked) {
									list21_id = this.gg_info.list21.data[j].id;
								}
							}
						}
					}
				}
				let shape = 0,
					areas = 0; //散热开孔形状和开孔面积
				for(let i = 0; i < this.gg_info.list19.data[0].pid_data.length; i++) { //散热开孔形状
					if(this.gg_info.list19.data[0].pid_data[i].checked) {
						shape = this.gg_info.list19.data[0].pid_data[i].id;
						break;
					}
				}
				for(let i = 0; i < this.gg_info.list19.data[1].pid_data.length; i++) { //散热开孔面积
					if(this.gg_info.list19.data[1].pid_data[i].checked) {
						areas = this.gg_info.list19.data[1].pid_data[i].id;
						break;
					}
				}

				let attr_info_id = 0; //厚度id
				for(let i = 0; i < this.thickness.length; i++) { //散热开孔面积
					if(this.thickness[i].checked) {
						attr_info_id = this.thickness[i].id;
						break;
					}
				}

				if(num == 1) { //保存
					api.editShopCar({
						token: this.getCookie('token'),
						id: this.$route.query.id,
						attr_id: this.attrs.id,
						attr_info_id: attr_info_id, //厚度
						price: this.money,
						make_demand: list1_id,
						other_product: list2_id,
						mesh_purpose: list3_id,
						mark_craft: list4_id,
						thick_num: list5_id,
						laser_marking: list6_id,
						mark_point: list7_id,
						solder_hole: list8_id,
						solder_hole_size: list8_id2,
						solder_hole_type: list9_id,
						glue_hole_type: list10_id,
						compose_type: list11_id,
						handle_demand: list12_id,
						pdf_file: this.files,
						pdf_file_content: list13_id.join(','),
						is_invoice: this.is_invoice,
						invoice_title: this.invoice_head,
						is_fast: list15_id,
						message: this.remark,
						order_level: this.attrs.level,
						mesh_type: mesh_type,
						mesh_num: this.mesh_num,
						ic_open_ask: list17_id,
						ic_open_ask_size: list17_id2,
						ic_open_shape: list20_id,
						bga_open_ask: list18_id,
						bga_open_ask_size: list18_id2,
						bga_open_shape: list21_id,
						pad_open_shape: shape,
						pad_open_area: areas,
						buy_num: this.num,
					}).then((res) => {
						if(res.code == 1) {
							layer.msg('保存成功', {
								icon: 1,
								anim: 5
							})
							_this.$router.replace({
								path: '/shopCar',
							})
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				} else if(num == 2) { //立即下单
					api.createOrder({
						shopcar_id: this.shopcar_id,
						token: this.getCookie('token'),
						address_id: this.selAddr.id,
						contact_id: this.selCont.id,
						price: this.money + parseFloat(this.kd_money),
						attr_id: this.attrs.id,
						attr_info_id: attr_info_id, //厚度
						make_demand: list1_id,
						other_product: list2_id,
						mesh_purpose: list3_id,
						mark_craft: list4_id,
						thick_num: list5_id,
						laser_marking: list6_id,
						mark_point: list7_id,
						solder_hole: list8_id,
						solder_hole_size: list8_id2,
						solder_hole_type: list9_id,
						glue_hole_type: list10_id,
						compose_type: list11_id,
						handle_demand: list12_id,
						pdf_file: this.files,
						pdf_file_content: list13_id.join(','),
						is_invoice: this.is_invoice,
						invoice_title: this.invoice_head,
						is_fast: list15_id,
						message: this.remark,
						order_level: this.attrs.level,
						mesh_type: mesh_type,
						mesh_num: this.mesh_num,
						express_id: this.kd_info[this.kd_index].id,
						type: this.kd_type,
						ic_open_ask: list17_id,
						ic_open_ask_size: list17_id2,
						ic_open_shape: list20_id,
						bga_open_ask: list18_id,
						bga_open_ask_size: list18_id2,
						bga_open_shape: list21_id,
						pad_open_shape: shape,
						pad_open_area: areas,
						buy_num: this.num
					}).then((res) => {
						if(res.code == 1) {
							_this.$router.replace({
								path: '/orderDetail',
								query: {
									id: res.data
								}
							})
						} else {
							layer.msg(res.msg, {
								icon: 2,
								anim: 6
							})
						}
					})
				}
			},
			selThickness(index) {
				for(let i = 0; i < this.thickness.length; i++) {
					if(index == i) {
						this.thickness[i].checked = 1;
					} else {
						this.thickness[i].checked = 0;
					}
				}
				this.total();
			},
			selList1(index) {
				for(let i = 0; i < this.gg_info.list1.data.length; i++) {
					if(index == i) {
						this.gg_info.list1.data[i].checked = 1;
					} else {
						this.gg_info.list1.data[i].checked = 0;
					}
				}
				this.total();
			},
			selList2(index) {
				for(let i = 0; i < this.gg_info.list2.data.length; i++) {
					if(index == i) {
						this.gg_info.list2.data[i].checked = 1;
					} else {
						this.gg_info.list2.data[i].checked = 0;
					}
				}
				this.total();
			},
			selList3(index) {
				for(let i = 0; i < this.gg_info.list3.data.length; i++) {
					if(index == i) {
						this.gg_info.list3.data[i].checked = 1;
					} else {
						this.gg_info.list3.data[i].checked = 0;
					}
					if(index <= 4) {
						this.mesh_type = 1;
					} else {
						this.mesh_type = 2;
						this.gg_info.list10.data[0].checked = 1;
					}
				}
				this.total();
			},
			selList4(index) {
				for(let i = 0; i < this.gg_info.list4.data.length; i++) {
					if(index == i) {
						this.gg_info.list4.data[i].checked = 1;
					} else {
						this.gg_info.list4.data[i].checked = 0;
					}
				}
				this.total();
			},
			selList5(index) {
				for(let i = 0; i < this.gg_info.list5.data.length; i++) {
					if(index == i) {
						this.gg_info.list5.data[i].checked = 1;
					} else {
						this.gg_info.list5.data[i].checked = 0;
					}
				}
				this.total();
			},
			selList6(index) {
				for(let i = 0; i < this.gg_info.list6.data.length; i++) {
					if(index == i) {
						this.gg_info.list6.data[i].checked = 1;
					} else {
						this.gg_info.list6.data[i].checked = 0;
					}
				}
				this.total();
			},
			selList7(index) {
				for(let i = 0; i < this.gg_info.list7.data.length; i++) {
					if(index == i) {
						this.gg_info.list7.data[i].checked = 1;
					} else {
						this.gg_info.list7.data[i].checked = 0;
					}
				}
				this.total();
			},
			selList8(index) {
				for(let i = 0; i < this.gg_info.list8.data.length; i++) {
					if(index == i) {
						this.gg_info.list8.data[i].checked = 1;
						this.gg_info.list8.data[i].p_checked = 1;
						if(this.gg_info.list8.data[i].pid_data) {
							this.gg_info.list8.data[i].pid_data[0].checked = 1;
						}
					} else {
						this.gg_info.list8.data[i].checked = 0;
						this.gg_info.list8.data[i].p_checked = 0;
					}
					if(index == 0 || index == 1) {
						for(let i = 0; i < this.gg_info.list9.data.length; i++) {
							this.gg_info.list9.data[i].checked = 0;
						}
					} else {
						for(let j = 0; j < this.gg_info.list9.data.length; j++) {
							if(j == 0) {
								this.gg_info.list9.data[j].checked = 1;
							} else {
								this.gg_info.list9.data[j].checked = 0;
							}
						}
					}
				}
				this.total();
			},
			selList8Tow(index, index2) {
				for(let i = 0; i < this.gg_info.list8.data[index].pid_data.length; i++) {
					if(index2 == i) {
						this.gg_info.list8.data[index].pid_data[i].checked = 1;
					} else {
						this.gg_info.list8.data[index].pid_data[i].checked = 0;
					}
				}
				this.total();
			},
			selList9(index) {
				for(let i = 0; i < this.gg_info.list9.data.length; i++) {
					if(index == i) {
						this.gg_info.list9.data[i].checked = 1;
					} else {
						this.gg_info.list9.data[i].checked = 0;
					}
				}
				this.total();
			},
			selList10(index) {
				for(let i = 0; i < this.gg_info.list10.data.length; i++) {
					if(index == i) {
						this.gg_info.list10.data[i].checked = 1;
					} else {
						this.gg_info.list10.data[i].checked = 0;
					}
				}
				this.total();
			},
			selList11(index) {
				for(let i = 0; i < this.gg_info.list11.data.length; i++) {
					if(index == i) {
						this.gg_info.list11.data[i].checked = 1;
					} else {
						this.gg_info.list11.data[i].checked = 0;
					}
				}
				this.total();
			},
			selList12(index) {
				let _this = this;
				if(index == 0) {
					this.gg_info.list12.data[0].checked = 1;
					this.gg_info.list12.data[1].checked = 0;
				} else {
					this.zzc = true;
					layer.open({
						title: '',
						closeBtn: 0,
						type: 1,
						content: $('#lay-box'),
						shade: 0,
						btnAlign: 'c',
						btn: ['需要确认', '不需要确认PDF文档'],
						cancel: function() {
							_this.zzc = false;
						},
						yes: function() {
							layer.closeAll();
							_this.showLayer2();
						},
						btn2: function() {
							layer.closeAll();
							_this.zzc = false;
						}
					});
				}
			},
			showLayer2() {
				let _this = this;
				layer.open({
					title: '',
					closeBtn: 0,
					type: 1,
					content: $('#lay-box2'),
					shade: 0,
					btnAlign: 'c',
					btn: ['需要确认', '不需要确认PDF文档'],
					cancel: function() {
						_this.zzc = false;
					},
					yes: function() {
						layer.closeAll();
						_this.showLayer3();
					},
					btn2: function() {
						layer.closeAll();
						_this.zzc = false;
					}
				})
			},
			showLayer3() {
				let _this = this;
				layer.open({
					title: '',
					closeBtn: 0,
					type: 1,
					content: $('#lay-box3'),
					shade: 0,
					btnAlign: 'c',
					btn: ['需要确认', '不需要确认PDF文档'],
					cancel: function() {
						_this.zzc = false;
					},
					yes: function() {
						layer.closeAll();
						_this.zzc = false;
						_this.gg_info.list12.data[0].checked = 0;
						_this.gg_info.list12.data[1].checked = 1;
					},
					btn2: function() {
						layer.closeAll();
						_this.zzc = false;
					}
				})
			},
			selList13(index) {
				if(this.gg_info.list13.data[index].checked == 1) {
					this.gg_info.list13.data[index].checked = 0;
				} else {
					this.gg_info.list13.data[index].checked = 1;
				}
				this.total();
			},
			confirm(index) {
				this.all_dataIsok = !this.all_dataIsok;
			},
			selList14(index) {
				this.is_invoice = index;
			},
			selList15(index) {
				for(let i = 0; i < this.gg_info.list15.data.length; i++) {
					if(index == i) {
						this.gg_info.list15.data[i].checked = 1;
					} else {
						this.gg_info.list15.data[i].checked = 0;
					}
				}
				this.total();
			},
			selList16(index) {
				this.all_dataIsok2 = !this.all_dataIsok2;
			},
			selList17(index) {
				for(let i = 0; i < this.gg_info.list17.data.length; i++) {
					if(index == i) {
						this.gg_info.list17.data[i].checked = 1;
						this.gg_info.list17.data[i].p_checked = 1;
						if(this.gg_info.list17.data[i].pid_data) {
							this.gg_info.list17.data[i].pid_data[0].checked = 1;
							for(let i = 0; i < this.gg_info.list20.data.length; i++) {
								this.gg_info.list20.data[i].checked = 0;
							}
							this.gg_info.list20.data[0].checked = 1;
						}
					} else {
						this.gg_info.list17.data[i].checked = 0;
						this.gg_info.list17.data[i].p_checked = 0;
					}
				}
			},
			selList17Tow(index, index2) {
				let _this = this;
				for(let i = 0; i < this.gg_info.list17.data[index].pid_data.length; i++) {
					if(index2 == i) {
						this.$set(this.gg_info.list17.data[index].pid_data[i],'checked',1);
					} else {
						this.$set(this.gg_info.list17.data[index].pid_data[i],'checked',0);
					}
				}
			},
			selList18(index) {
				for(let i = 0; i < this.gg_info.list18.data.length; i++) {
					if(index == i) {
						this.gg_info.list18.data[i].checked = 1;
						this.gg_info.list18.data[i].p_checked = 1;
						if(this.gg_info.list18.data[i].pid_data) {
							this.gg_info.list18.data[i].pid_data[0].checked = 1;
							for(let i = 0; i < this.gg_info.list21.data.length; i++) {
								this.gg_info.list21.data[i].checked = 0;
							}
							this.gg_info.list21.data[0].checked = 1;
						}
					} else {
						this.gg_info.list18.data[i].checked = 0;
						this.gg_info.list18.data[i].p_checked = 0;
					}
				}
			},
			selList18Tow(index, index2) {
				for(let i = 0; i < this.gg_info.list18.data[index].pid_data.length; i++) {
					if(index2 == i) {
						this.$set(this.gg_info.list18.data[index].pid_data[i],'checked',1);
					} else {
						this.$set(this.gg_info.list18.data[index].pid_data[i],'checked',0);
					}
				}
			},
			selList19Tow(index, index2) {
				for(let i = 0; i < this.gg_info.list19.data[index].pid_data.length; i++) {
					if(index2 == i) {
						this.$set(this.gg_info.list19.data[index].pid_data[i],'checked',1);
					} else {
						this.$set(this.gg_info.list19.data[index].pid_data[i],'checked',0);
					}
				}
			},
			selList20(index) {
				for(let i = 0; i < this.gg_info.list20.data.length; i++) {
					if(index == i) {
						this.gg_info.list20.data[i].checked = 1;
					} else {
						this.gg_info.list20.data[i].checked = 0;
					}
				}
			},
			selList21(index) {
				for(let i = 0; i < this.gg_info.list21.data.length; i++) {
					if(index == i) {
						this.gg_info.list21.data[i].checked = 1;
					} else {
						this.gg_info.list21.data[i].checked = 0;
					}
				}
			},
			selAddress() {
				if(this.address != [] && this.address.length > 0) {
					layer.open({
						type: 1,
						title: '选择收货地址',
						content: $('#address'),
						shade: 0,
						area: '1000px'
					});
				} else {
					api.getAddressList({ //获取收货地址
						token: this.getCookie('token')
					}).then((res) => {
						if(res.code == 1) {
							this.address = res.data;
							layer.open({
								type: 1,
								title: '选择收货地址',
								content: $('#address'),
								shade: 0,
								area: '1000px'
							});
						} else {
							layer.msg('获取收货地址失败', {
								icon: 2,
								anim: 6
							})
						}
					})
				}
			},
			setTheAddr(item) {
				this.selAddr = item;
				this.expressDetail(item);
				layer.closeAll();
			},
			selContact() {
				if(this.contact != [] && this.contact.length > 0) {
					layer.open({
						type: 1,
						title: '选择订单联系人',
						content: $('#contact'),
						shade: 0,
						area: '1000px'
					});
				} else {
					api.getContactList({ //获取联系人
						token: this.getCookie('token')
					}).then((res) => {
						if(res.code == 1) {
							this.contact = res.data;
							layer.open({
								type: 1,
								title: '选择订单联系人',
								content: $('#contact'),
								shade: 0,
								area: '1000px'
							});
						} else {
							layer.msg('获取联系人失败', {
								icon: 2,
								anim: 6
							})
						}
					})
				}
			},
			setTheContact(item) {
				this.selCont = item;
				layer.closeAll();
			}
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.bigImg {
		width: 800px;
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 10000;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.bigImg img {
		width: 800px;
	}
	
	.bigImg i {
		position: absolute;
		top: 0;
		right: 0;
		transform: translate(20px, -20px);
		z-index: 10001;
	}
	
	#lay-box,
	#lay-box2,
	#lay-box3 {
		padding: 20px 30px;
	}
	
	.text_color {
		display: block;
		color: rgba(72, 118, 255, 1);
	}
	
	.creatOrder {
		font-family: SourceHanSansSC;
	}
	
	.ggBox {
		border: 2px solid #ddd;
		width: 94%;
		margin: 30px 3%;
		border-radius: 10px;
		overflow: hidden;
	}
	
	.ggBox>div {
		border-bottom: 1px solid #ccc;
		min-height: 80px;
	}
	
	.ggBox>div:last-child {
		border: none;
	}
	
	.ggBox .tt_width {
		width: 114px;
		min-width: 114px;
		text-align: center;
	}
	
	.ggBox>div>span {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		width: 150px;
		/*min-width: 114px;*/
		min-height: 80px;
		height: 100%;
		text-align: center;
	}
	
	.ggBox>div>div {
		border-left: 1px solid #ccc;
		min-height: 80px;
	}
	
	.ggBox>div>div span {
		margin-left: 10px;
	}
	
	.ggBox>div>div i {
		margin: 6px 0 6px 10px;
	}
	
	.proBox {
		padding: 70px 0;
		border-bottom: 1px solid #eee;
		margin-bottom: 40px;
	}
	
	.proBox>div {
		width: 75%;
		margin-left: 12.5%;
		height: 20px;
		background: #ccc;
		border-radius: 50px;
		position: relative;
	}
	
	.proBox>div>div {
		position: absolute;
		left: 0;
		top: 0;
		width: 33.33%;
		height: 100%;
		border-radius: 50px;
	}
	
	.proBox .a,
	.proBox .b {
		position: absolute;
		width: 65px;
		/* width */
		display: flex;
		flex-direction: column;
		align-items: center;
		-webkit-transform: translateY(-25px);
		-moz-transform: translateY(-25px);
		-ms-transform: translateY(-25px);
		-o-transform: translateY(-25px);
		transform: translateY(-25px);
	}
	
	.proBox .a span:first-child,
	.proBox .b span:first-child {
		width: 50px;
		font-weight: 700;
		background: #ccc;
		line-height: 50px;
		border-radius: 50%;
		color: #fff;
		font-size: 32px;
		text-align: center;
		margin-bottom: 10px;
		font-family: Roboto, BlinkMacSystemFont, 'Helvetica Neue', Arial, 'Microsoft Yahei', 'WenQuanYi Micro Hei', 'Pingfang SC', sans-serif;
	}
	
	.proBox .a {
		left: 30%;
		top: 50%;
	}
	
	.proBox .b {
		left: 66%;
		top: 50%;
	}
	
	.selAddr {
		/*color: #01AAED;*/
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		height: 100%;
		line-height: 26px;
		cursor: pointer;
		padding: 0 30px;
		font-size: 14px;
	}
	
	.redio {
		cursor: pointer;
	}
	
	.layer {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		background: rgba(0, 0, 0, 0.3);
		z-index: 10000;
	}
</style>


// WEBPACK FOOTER //
// src/components/goods.vue